import React, { useEffect, useRef, useState } from 'react';
import api from '../api/api';

export default function GoogleLoginButton({ onSuccess, onError }) {
  const buttonRef = useRef(null);
  const pendingRef = useRef(false);
  const [status, setStatus] = useState('正在加载 Google 登录…');

  useEffect(() => {
    let active = true;
    let script;
    let initialize;
    const failed = () => {
      if (active) {
        setStatus('Google 登录暂不可用，请刷新重试或使用邮箱密码登录。');
        onError('Google 登录加载失败');
      }
    };
    api.getGoogleLoginConfig().then(({ data }) => {
      if (!active) return;
      if (!data.client_id) {
        setStatus('Google 登录尚未配置，请联系管理员。');
        return;
      }
      initialize = () => {
        if (!active) return;
        window.google.accounts.id.initialize({
          client_id: data.client_id, nonce: data.nonce, hd: 'shopline.com', auto_select: false,
          callback: async ({ credential }) => {
            if (!active || pendingRef.current) return;
            pendingRef.current = true;
            setStatus('正在验证 Google 账号…');
            onError('');
            try {
              const response = await api.googleLogin(credential);
              if (active) onSuccess(response);
            } catch (error) {
              if (active) {
                onError(error.response?.data?.detail || 'Google 登录失败，请重试');
                setStatus('');
              }
            } finally {
              pendingRef.current = false;
            }
          }
        });
        buttonRef.current.replaceChildren();
        window.google.accounts.id.renderButton(buttonRef.current, { theme: 'outline', size: 'large', text: 'signin_with', locale: 'zh_CN' });
        setStatus('');
      };
      if (window.google?.accounts?.id) {
        initialize();
        return;
      }
      script = document.getElementById('google-identity-client');
      if (!script) {
        script = document.createElement('script');
        script.id = 'google-identity-client';
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        document.head.appendChild(script);
      }
      script.addEventListener('load', initialize);
      script.addEventListener('error', failed);
    }).catch(failed);
    return () => {
      active = false;
      script?.removeEventListener('load', initialize);
      script?.removeEventListener('error', failed);
    };
  }, [onSuccess, onError]);

  return <div className="google-login">
    <div ref={buttonRef} />
    {status && <p className="google-login-status" role="status">{status}</p>}
  </div>;
}
